import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { Table, Ref, Loader, Message, Icon } from 'semantic-ui-react'
import ReactResizeDetector from 'react-resize-detector'

import './Table.css'

const HEADER = {
  ELEM: 'xxxHEADERxxx',
  TEXT: 'text',
  FOREGROUND: 'foreground',
  BACKGROUND: 'background'
}

class TableComponent extends React.Component {

  static headerRow(text, foreground='000000', background='e0e0e0') {
    return {
      [HEADER.ELEM]: {
        [HEADER.TEXT]: text,
        [HEADER.FOREGROUND]: foreground,
        [HEADER.BACKGROUND]: background
      }
    }
  }

  constructor(props) {

    // Properties
    super(props)

    // Bind events
    this.registerTableHeadRef = this.registerTableHeadRef.bind(this)
    this.registerTableBodyRef = this.registerTableBodyRef.bind(this)
    this.onResizeWrapper = this.onResizeWrapper.bind(this)
  }

  registerTableHeadRef(thead) {
    this.tableHead = thead
  }

  registerTableBodyRef(tbody) {
    this.tableBody = tbody
  }

  onResizeWrapper(width, height) {
    const headHeight = this.tableHead.clientHeight
    let bodyMaxHeight = height - headHeight
    if (bodyMaxHeight < 0) {
      bodyMaxHeight = 0
    }
    this.tableBody.style.maxHeight = bodyMaxHeight + 'px'
  }

  render() {
    return (
      <div
        className={`library-table-wrapper${ this.props.float ? ' float' : '' }`}
        style={this.props.style || {}}
      >
        <Table
          selectable={
            !this.props.isLoading
            &&
            _.isNull(this.props.error)
            &&
            _.isArray(this.props.data)
            &&
            _.size(this.props.data) > 0
          }
          compact
          className='library-table'
          color={this.props.color}
        >
          <Ref innerRef={this.registerTableHeadRef}>
            <Table.Header>
              <Table.Row>
                {
                  _.map(this.props.columns, (column) => (
                    <Table.HeaderCell
                      key={column.id}
                      style={
                        column.hierarchy
                          ? {
                              width: String(
                                column.hierarchy.eachWidth * column.hierarchy.colspan
                              ) + 'px'
                            }
                          : (
                              _.extend(
                                _.isNull(column.width)
                                  ? {}
                                  : { width: column.width },
                                column.align
                                  ? { textAlign: column.align }
                                  : {},
                                column.compact === true
                                  ? {
                                      paddingLeft: '3px',
                                      paddingRight: '3px'
                                    }
                                  : {},
                              )
                            )
                      }
                      colSpan={
                        column.hierarchy
                          ? String(column.hierarchy.colspan)
                          : '1'
                      }
                    >
                      {column.title}
                    </Table.HeaderCell>
                  ))
                }
              </Table.Row>
            </Table.Header>
          </Ref>
          <Ref innerRef={this.registerTableBodyRef}>
            <Table.Body>
              {
                this.props.isLoading
                  ? (
                      <Table.Row className='library-table-filling-row'>
                        <Loader active inline='centered' size='medium' />
                      </Table.Row>
                    )
                  : (
                      _.isNull(this.props.error)
                        ? (
                            _.isArray(this.props.data) && _.size(this.props.data) > 0
                              ? _.map(this.props.data, (row) => (
                                  <Table.Row
                                    key={row.id}
                                    warning={
                                      row.id === this.props.selectedId
                                      &&
                                      !_.isUndefined(row.id)
                                    }
                                  >
                                    {
                                      _.isUndefined(row[HEADER.ELEM])
                                        ? _.map(this.props.columns, (col) => {
                                            if (col.hierarchy) {
                                              return (
                                                <React.Fragment key={col.id}>
                                                  <Table.Cell
                                                    style={{
                                                      width: String(col.hierarchy.eachWidth * row.level) + 'px',
                                                      padding: '7px 0',
                                                      lineHeight: (
                                                        row.children && row.children.length
                                                          ? '10.5px'
                                                          : '7px'
                                                      )
                                                    }}
                                                    colSpan={String(row.level)}
                                                    textAlign='right'
                                                  >
                                                    <Icon
                                                      name={
                                                        row.children && row.children.length
                                                          ? 'caret down'
                                                          : 'circle'
                                                      }
                                                      size={
                                                        row.children && row.children.length
                                                          ? 'small'
                                                          : 'tiny'
                                                      }
                                                      fitted={true}
                                                    />
                                                  </Table.Cell>
                                                  <Table.Cell
                                                    style={{
                                                      width: String(
                                                        col.hierarchy.eachWidth * (
                                                          col.hierarchy.colspan - row.level
                                                        )
                                                      ) + 'px'
                                                    }}
                                                    colSpan={String(col.hierarchy.colspan - row.level)}
                                                  >
                                                    {
                                                      _.isFunction(col.render)
                                                        ? col.render(row, this.props.data)
                                                        : row[col.id]
                                                    }
                                                  </Table.Cell>
                                                </React.Fragment>
                                              )
                                            }
                                            else {
                                              return (
                                                <Table.Cell
                                                  key={col.id}
                                                  style={
                                                    _.extend(
                                                      {},
                                                      _.isNull(col.width)
                                                        ? {}
                                                        : { width: col.width },
                                                      col.align
                                                        ? { textAlign: col.align }
                                                        : {},
                                                      col.compact === true
                                                        ? {
                                                            paddingLeft: '3px',
                                                            paddingRight: '3px'
                                                          }
                                                        : {},
                                                      col.smallText === true
                                                        ? {
                                                            fontSize: '0.85em'
                                                          }
                                                        : {},
                                                      col.stickers === true
                                                        ? {
                                                            paddingTop: '3px',
                                                            paddingBottom: '3px'
                                                          }
                                                        : {}
                                                    )
                                                  }
                                                >
                                                  {
                                                    _.isFunction(col.render)
                                                      ? col.render(row, this.props.data)
                                                      : row[col.id]
                                                  }
                                                </Table.Cell>
                                              )
                                            }

                                          })
                                        : <Table.Cell
                                            colSpan={String(_.size(this.props.columns))}
                                            style={{
                                              color: '#' + row[HEADER.ELEM][HEADER.FOREGROUND],
                                              backgroundColor: '#' + row[HEADER.ELEM][HEADER.BACKGROUND]
                                            }}
                                          >
                                            {row[HEADER.ELEM][HEADER.TEXT]}
                                          </Table.Cell>
                                    }
                                  </Table.Row>
                                ))
                              : <Table.Row className='library-table-filling-row'>
                                  <Message
                                    icon='meh'
                                    content={this.props.emptyMessage}
                                  />
                                </Table.Row>
                          )
                        : (
                            <Table.Row className='library-table-filling-row'>
                              <Message
                                negative
                                icon='exclamation circle'
                                content={this.props.error.message}
                              />
                            </Table.Row>
                          )
                    )
              }
              {

              }
            </Table.Body>
          </Ref>
        </Table>
        <ReactResizeDetector
          handleHeight
          onResize={this.onResizeWrapper}
        />
      </div>
    )
  }

}

TableComponent.propTypes = {
  // List of columns
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      // Internal ID of the column
      id: PropTypes.string.isRequired,

      // Title displayed for the column
      title: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.element.isRequired
      ]).isRequired,

      // Function to map input row to actual cell content
      // (dataRow) => (columnContent)
      // if not specified, uses id to access dataRow
      render: PropTypes.func,

      // Hierarchy configuration if the table is to be used as a hierarchy
      // visualization.
      // The below width property will be ignored if used.
      // Each row must have a "level" property, starting at 1, indicating how
      // deep in the tree the element lies
      hierarchy: PropTypes.shape({

        // Number of cells to aggregate to form the full column
        colspan: PropTypes.number.isRequired,

        // Width of each cell, in pixels
        eachWidth: PropTypes.number.isRequired
      }),

      // Width of the column, may use px or % or left null
      width: PropTypes.string,

      // Make the cell compact by reducing left and right padding, useful for
      // action buttons
      compact: PropTypes.bool,

      // Alignment of the text inside the cell, 'left', 'center' or 'right'
      align: PropTypes.string,

      // Make the text slightly smaller
      smallText: PropTypes.bool,

      // Make the cell contain stickers by reducing top and bottom padding
      stickers: PropTypes.bool
    })
  ).isRequired,

  // Data content
  data: PropTypes.arrayOf(
    PropTypes.object
  ).isRequired,

  // Error content
  error: PropTypes.object,

  // Indicate when table is loading
  isLoading: PropTypes.bool.isRequired,

  // ID of the selected row, if any
  selectedId: PropTypes.number,

  // Message to display when the table is empty
  emptyMessage: PropTypes.string.isRequired,

  // Color of the table
  color: PropTypes.string,

  // Make the table floating to surrounding component
  float: PropTypes.bool
}

export default TableComponent



// WEBPACK FOOTER //
// ./src/components/elements/Table.js